import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor() { }

  changeOperation(selectedDate: string, createdAt: string, type: string): string {
    if (!selectedDate || !createdAt) return '';

    const baseDate = new Date(createdAt);
    const compareDate = new Date(selectedDate);

    // Validate date parsing
    if (isNaN(baseDate.getTime()) || isNaN(compareDate.getTime())) return '';

    const diffInMilliseconds = compareDate.getTime() - baseDate.getTime();
    let diffInYears = diffInMilliseconds / (1000 * 60 * 60 * 24 * 365.25); // approx
    if(diffInYears < 0) diffInYears *= -1;

    console.log(`Years diff: ${diffInYears}`);


    if (type === 'entity') {
      if (diffInYears <= 10) {
        return 'Startup';
      } else if (diffInYears > 10) {
        return 'openApplicantUnit';
      }
    } else if (type === 'appUnit') {
      if (diffInYears <= 3) {
        return 'Rising Star';
      } else if (diffInYears > 3 && diffInYears <= 10) {
        return ''; // Mid-range category if needed
      }
    }

    return '';
  }

  autoCalculateStartupOrRiging(entityDate: string, appliDate: string, createdDate: string): string {
    let value = this.changeOperation(entityDate, createdDate, 'entity');
   
    if (value == 'openApplicantUnit') {
      let value = this.changeOperation(appliDate, createdDate, 'appUnit');
      return value;
    } else {
      return value;
    }
  }
}
